import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mt-24" }
const _hoisted_2 = { class: "text-3xl text-center font-bold mt-9 text-black-main" }
const _hoisted_3 = { class: "mt-4 text-center font-medium text-xs text-portal-darkgrey" }
const _hoisted_4 = { class: "text-center text-sm description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "error" }, null, -1)),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.errorCode), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t("Deposit_Error_Description")), 1)
    ])
  ]))
}